module.exports = __webpack_public_path__ + "media/images/logo-mybenefits-5fb1d09a4acc509d046d83234a151267.svg";